module.exports = {"522630001":"台拱街道","522630002":"萃文街道","522630101":"施洞镇","522630102":"南宫镇","522630103":"革一镇","522630104":"方召镇","522630201":"排羊乡","522630202":"台盘乡","522630204":"老屯乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/522630.json
// module id = 2653
// module chunks = 0